import { render } from "./CreateTransfer.vue?vue&type=template&id=d042e92c"
import script from "./CreateTransfer.vue?vue&type=script&lang=js"
export * from "./CreateTransfer.vue?vue&type=script&lang=js"
script.render = render

export default script